import {Component, Input} from "@angular/core";


@Component({
  selector: 'loading',
  templateUrl: 'loading.component.html'
})

export class LoadingComponent {
  @Input() class: string;
}



// WEBPACK FOOTER //
// ./src/app/tokbox/components/loading/loading.component.ts